import { UserAccountsResponse } from "@/types/FirebaseFunctionsResponses";
import { Functions, httpsCallable } from "firebase/functions";

export class UserAccountsApiService {
  private functions: Functions;

  constructor(functions: Functions) {
    this.functions = functions;
  }

  async getAccounts(): Promise<UserAccountsResponse | undefined> {
    try{
      const getUserAccount = httpsCallable(this.functions, 'getUserAccount');
      const result = await getUserAccount();
      const response: UserAccountsResponse = result.data as UserAccountsResponse;

      console.log("firebaseFunctionsApi.getAccounts response:", response);
      return response;
    }
    catch(e){
      console.error("UserAccountsApi.getAccounts error:", e);
      return undefined;
    }
  }
}

